import { Icon } from "@iconify/react";

import {
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";

import "./Builder.css";

const Builder = ({ chatbotValues, updateChatbotValues }) => {
  // To render option route destinations
  const renderSectionRoutes = (currentSection, isHandler) => {
    let renderedSectionRoutes;

    // Route destinations
    renderedSectionRoutes = chatbotValues.sections
      // Remove the current section and end section
      .filter((sectionRoutes) => {
        if (!isHandler) {
          // Skip for handlers
          return (
            sectionRoutes.section_id !== currentSection.section_id &&
            sectionRoutes.section_id !== "end"
          );
        } else {
          return sectionRoutes;
        }
      })
      .map((sectionRoutes) => (
        <MenuItem
          key={sectionRoutes.section_id}
          value={sectionRoutes.section_id}
        >{`${sectionRoutes.section_id} (${
          sectionRoutes.name ? sectionRoutes.name : "Section name"
        })`}</MenuItem>
      ));

    // Additional options (return prev & return main)
    !isHandler && // Skip for handlers
      currentSection.type !== "start" && // Hidden for start section
      renderedSectionRoutes.push([
        <MenuItem key="return" value="prev">
          Return previous
        </MenuItem>,

        <MenuItem key="main" value="main">
          Return main
        </MenuItem>,
      ]);

    // Additional options (end)
    !isHandler && // Skip for handlers
      renderedSectionRoutes.push(
        <MenuItem key="end" value="end">
          End
        </MenuItem>
      );

    return renderedSectionRoutes;
  };

  return (
    <section className="chatbot-builder">
      <p className="title">Builder</p>

      <div className="sections">
        {chatbotValues.sections.map((section, index, arr) => (
          <section key={section.section_id}>
            <div className="section-contents">
              <header>
                <p className="section-number">{`${section.section_id}`}</p>
              </header>

              <section className="section-details">
                <TextField
                  label="Section name"
                  placeholder="Insert name..."
                  value={section.name}
                  onChange={(e) =>
                    updateChatbotValues((draft) => {
                      draft.sections[index].name = e.target.value;
                    })
                  }
                />

                <TextField
                  InputProps={{
                    // Uneditable for start and end sections
                    readOnly: index === 0 || index === arr.length - 1,
                  }}
                  label="Action"
                  required
                  select
                  value={section.type}
                  onChange={(e) =>
                    updateChatbotValues((draft) => {
                      draft.sections[index].type = e.target.value;
                    })
                  }
                >
                  <MenuItem value="start">Start</MenuItem>
                  <MenuItem value="options">Options</MenuItem>
                  <MenuItem value="assign">Assign Agent</MenuItem>
                  <MenuItem value="end">End</MenuItem>
                </TextField>

                {
                  // Only show in start and options type
                  (section.type === "start" || section.type === "options") && (
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <div className="selection-option-buttons">
                              <Icon
                                className={
                                  section.options.length >= 9 ? "disabled" : ""
                                }
                                color="#727272"
                                height="18"
                                icon="tabler:chevron-up"
                                onClick={() => {
                                  section.options.length < 9 &&
                                    updateChatbotValues((draft) => {
                                      const newSection = {
                                        section_id: `section${
                                          draft.sections.length - 1
                                        }`,

                                        name: "",
                                        type: "end",
                                        value: "",
                                        options: [{ route: "end", key: "" }],
                                      };

                                      // Push new section just before end section
                                      draft.sections.splice(-1, 0, newSection);

                                      // Push new option
                                      draft.sections[index].options.push({
                                        route: `section${
                                          draft.sections.length - 2
                                        }`,

                                        key: "",
                                      });
                                    });
                                }}
                              />

                              <Icon
                                className={
                                  section.options.length <= 1 ? "disabled" : ""
                                }
                                color="#727272"
                                height="18"
                                icon="tabler:chevron-down"
                                onClick={() => {
                                  section.options.length > 0 &&
                                    updateChatbotValues((draft) => {
                                      // Remove one section just before end section
                                      draft.sections.splice(-2, 1);

                                      // Remove last option
                                      draft.sections[index].options.pop();
                                    });
                                }}
                              />
                            </div>
                          </InputAdornment>
                        ),

                        readOnly: true,
                      }}
                      label="Selection Options"
                      value={section.options?.length}
                    />
                  )
                }

                <TextField
                  autoComplete="false"
                  className="value"
                  label="Value"
                  multiline
                  maxRows={4}
                  placeholder="Insert text..."
                  required
                  value={section.value}
                  onChange={(e) =>
                    updateChatbotValues((draft) => {
                      draft.sections[index].value = e.target.value;
                    })
                  }
                />
              </section>

              {section.options && section.type !== "assign" && (
                <>
                  <hr />

                  <section className="section-options">
                    {section.options.map((option, indexOptions) => (
                      <>
                        <TextField
                          key={indexOptions}
                          label={`Option${indexOptions + 1}`}
                          select
                          value={option.route}
                          onChange={(e) =>
                            updateChatbotValues((draft) => {
                              draft.sections[index].options[
                                indexOptions
                              ].route = e.target.value;
                            })
                          }
                        >
                          {renderSectionRoutes(section)}
                        </TextField>

                        <TextField
                          autoComplete="false"
                          label="Key"
                          placeholder="Insert comma separated keys..."
                          required
                          value={option.key}
                          onChange={(e) =>
                            updateChatbotValues((draft) => {
                              draft.sections[index].options[indexOptions].key =
                                e.target.value;
                            })
                          }
                        />
                      </>
                    ))}
                  </section>
                </>
              )}
            </div>

            {
              // Hide on start and end sections
              index !== 0 && index !== arr.length - 1 && (
                <Tooltip arrow placement="top" title="Remove section">
                  <IconButton
                    onClick={() =>
                      updateChatbotValues((draft) => {
                        draft.sections.splice(index, 1);
                      })
                    }
                  >
                    <Icon color="#727272" height="28" icon="ph:x-bold" />
                  </IconButton>
                </Tooltip>
              )
            }
          </section>
        ))}

        <section>
          <div className="section-contents">
            <header>
              <p className="section-number">timeout</p>
            </header>

            <section className="section-details">
              <TextField
                label="Route"
                select
                value={chatbotValues.handlers.timeout.route}
                onChange={(e) =>
                  updateChatbotValues((draft) => {
                    draft.handlers.timeout.route = e.target.value;
                  })
                }
              >
                {renderSectionRoutes(null, true)}
              </TextField>

              <TextField
                autoComplete="false"
                label="Max time"
                placeholder="Insert time (in seconds)"
                required
                value={chatbotValues.handlers.timeout.max_time}
                onChange={(e) =>
                  updateChatbotValues((draft) => {
                    draft.handlers.timeout.max_time = Number(e.target.value);
                  })
                }
              />

              <TextField
                autoComplete="false"
                className="value"
                label="Value"
                multiline
                maxRows={4}
                placeholder="Insert text..."
                required
                value={chatbotValues.handlers.timeout.value}
                onChange={(e) =>
                  updateChatbotValues((draft) => {
                    draft.handlers.timeout.value = e.target.value;
                  })
                }
              />
            </section>
          </div>
        </section>

        <section>
          <div className="section-contents">
            <header>
              <p className="section-number">wrong input</p>
            </header>

            <section className="section-details">
              <TextField
                label="Route"
                select
                value={chatbotValues.handlers.wrong_input.route}
                onChange={(e) =>
                  updateChatbotValues((draft) => {
                    draft.handlers.wrong_input.route = e.target.value;
                  })
                }
              >
                {renderSectionRoutes(null, true)}
              </TextField>

              <TextField
                autoComplete="false"
                label="Max try"
                placeholder="Insert limit"
                required
                value={chatbotValues.handlers.wrong_input.max_try}
                onChange={(e) =>
                  updateChatbotValues((draft) => {
                    draft.handlers.wrong_input.max_try = Number(e.target.value);
                  })
                }
              />

              <TextField
                autoComplete="false"
                className="value"
                label="Value"
                multiline
                maxRows={4}
                placeholder="Insert text..."
                required
                value={chatbotValues.handlers.wrong_input.value}
                onChange={(e) =>
                  updateChatbotValues((draft) => {
                    draft.handlers.wrong_input.value = e.target.value;
                  })
                }
              />
            </section>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Builder;
